import { Card } from "@/src/components/cards";
import { Patient, SimpleExam } from "@/src/data/allTypes";
import { uid } from "@/src/utils/utils";
import moment from "moment";

export default function ExamSamplesButton({
  patient,
  exam,
  onChange,
}: {
  patient: Patient;
  exam: SimpleExam;
  onChange: (exam: SimpleExam) => void;
}) {
  if (!exam) return null;
  if (!exam.samples?.length) return null;
  if (exam.status == "finished") return null;
  return (
    <div className="c1 gap10">
      {exam.samples.map((sample) => {
        if (!sample) return null;
        console.log("sample.status", sample.status);
        if (sample.status == "finished") return null;
        return (
          <Card
            key={uid()}
            color="purple"
            title={<div>Prélevé</div>}
            subTitle={<div>{moment(sample?._date).format("LL à HH:mm")}</div>}
          ></Card>
        );
      })}
    </div>
  );
}
